import { createContext, useContext, useState, useCallback, useMemo } from 'react';

const SnapshotContext = createContext(null);

export function SnapshotProvider({ children }) {
    const [open, setOpen] = useState(false);

    const openSnapshot = useCallback(() => setOpen(true), []);
    const closeSnapshot = useCallback(() => setOpen(false), []);

    const value = useMemo(
        () => ({ open, openSnapshot, closeSnapshot }),
        [open, openSnapshot, closeSnapshot]
    );

    return (
        <SnapshotContext.Provider value={value}>
            {children}
        </SnapshotContext.Provider>
    );
}

export function useSnapshot() {
    const ctx = useContext(SnapshotContext);
    if (!ctx) throw new Error('useSnapshot must be used within SnapshotProvider');
    return ctx;
}
